import Link from "next/link";
import cx from "classnames";
import PropTypes from "prop-types";
import MediaItem from "@/components/MediaItem/MediaItem";
import Masonry from "react-masonry-css";
import { useEffect, useState } from "react";
import { useDeviceType } from "@/hooks/useDeviceType";

const breakpointColumnsObj = {
  default: 3, // 3 columns on desktop (as seen in your screenshot)
  1100: 2, // 2 columns on tablets
  767: 1, // 1 column on mobile devices
};

/***
 * @param {cardRows} array
 * @param {isLiterature} boolean
 * @returns
 */

const HomeArticleCard = ({
  cardRows = [],
  isLiterature = false,
  isIntelligent = false,
  isBidetSeat = false,
  isCadSymbol = false,
  isWaterFilterationES = false,
  isWaterFilterationEN = false,
  isFreeStandingBath = false,
  selectRow = 1,
}) => {
  const { isAbove } = useDeviceType(1101);
  const [col, setCol] = useState(0);
  const wrapperDivClass = cx(
    // "max-w-[290px]",
    // "break-inside-avoid mb-4 bg-white border rounded shadow"
    "mb-[10px] sm:mb-[0px]",
    "flex flex-col w-full"
    // "lg:min-h-[300px] relative bg-white max-md:mx-[25px] max-md:mt-[20px] max-md:mb-[10px] max-md:h-[280px]"
    // isLiterature
    //   ? "mx-2.5 my-5 cursor-pointer shadow-[2px_2px_5px_0_#aaa]"
    //   : `mx-2.5 mt-2 mb-1 cursor-pointer shadow-[2px_2px_5px_0_#aaa]`,
    // (isBidetSeat || isWaterFilterationES) && "w-[480px]"
  );

  /***
   * Purpose of creating this function is to render cards with or without link
   */
  const renderCards = fields => (
    <article className="cursor-pointer pb-4 max-md:pb-0 bg-white shadow-[2px_2px_5px_0_#aaa] w-full md:w-[290px] mx-auto mb-[10px]">
      {/* IMAGE + MOBILE OVERLAY */}
      <figure className="relative md:h-[230px]">
        <MediaItem assets={fields?.mediaItem} />

        {/* MOBILE CONTENT OVER IMAGE */}
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 to-transparent px-4 py-3 md:hidden">
          <h4
            className={`text-[#fff] text-[20px] leading-tight ${
              isBidetSeat ||
              isIntelligent ||
              isWaterFilterationES ||
              isWaterFilterationEN ||
              isFreeStandingBath
                ? "font-bold font-helveticaGroup text-left"
                : "font-medium font-helveticaLight"
            }`}
          >
            {fields?.heading}
          </h4>

          <h5
            className={`pt-1 text-white text-[14px] leading-[21px] truncate ${
              isBidetSeat ||
              isIntelligent ||
              isWaterFilterationES ||
              isWaterFilterationEN ||
              isFreeStandingBath
                ? "text-left"
                : ""
            }`}
          >
            {fields?.paragraphText}
          </h5>
        </div>
      </figure>

      {/* DESKTOP CONTENT */}
      <div className="hidden md:block">
        <h4
          className={`text-2xl p-5 text-[#333333] m-auto cursor-pointer ${
            isBidetSeat ||
            isIntelligent ||
            isWaterFilterationES ||
            isWaterFilterationEN ||
            isFreeStandingBath
              ? "m-0 text-[16px] text-left font-bold font-helveticaGroup"
              : "font-medium font-helveticaLight text-center"
          }`}
        >
          {fields?.heading}
        </h4>

        <h5
          className={`pt-1 pb-4 text-[#666] font-helveticaLight leading-snug ${
            isBidetSeat ||
            isIntelligent ||
            isWaterFilterationES ||
            isWaterFilterationEN ||
            isFreeStandingBath
              ? "text-left px-5"
              : "text-center px-6"
          }`}
        >
          {fields?.paragraphText}
        </h5>

        {fields?.cta &&
          fields?.cta?.map(({ fields, sys }) => (
            <Link key={sys?.id} href={fields?.url || ""} legacyBehavior>
              <a
                target={fields?.openerType !== "Current Window" ? "_blank" : ""}
                className={`flex w-full text-[16px] ${
                  isCadSymbol
                    ? "helveticaLight justify-center"
                    : "font-helveticaGroup justify-left hover:no-underline pl-5"
                }`}
                rel="noreferrer"
              >
                {fields?.label}
              </a>
            </Link>
          ))}
      </div>
    </article>
  );

  useEffect(() => {
    setCol(0);
    if (isAbove) setCol(selectRow - 1);
  }, [isAbove]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const item9 = document.getElementById("9");
    const columns = document.querySelectorAll(".flex.w-auto > div");
    if (!item9 || columns.length < 3) return;
    if (isAbove) {
      columns[selectRow - 1]?.appendChild(item9);
    } else {
      columns[0]?.appendChild(item9);
    }
  }, [isAbove, col]);

  return (
    <Masonry
      breakpointCols={breakpointColumnsObj}
      className="flex -ml-[10px] md:justify-center w-auto"
      columnClassName="md:!flex-none md:!w-auto  pl-0 md:pl-5 bg-clip-padding flex-1 cursor-pointer"
    >
      {cardRows?.map(({ fields, sys }, index) => (
        <div
          key={sys?.id}
          className={wrapperDivClass}
          id={index}
          style={{
            marginTop: index === 1 ? "30px" : "0px",
          }}
        >
          {fields?.url ? (
            <Link href={fields?.url ? fields.url : ""} legacyBehavior>
              {renderCards(fields)}
            </Link>
          ) : (
            renderCards(fields)
          )}
        </div>
      ))}
    </Masonry>
  );
};

HomeArticleCard.propTypes = {
  cardRows: PropTypes.arrayOf(PropTypes.shape({})),
  isLiterature: PropTypes.bool,
  isIntelligent: PropTypes.bool,
  isBidetSeat: PropTypes.bool,
  isCadSymbol: PropTypes.bool,
  isWaterFilterationES: PropTypes.bool,
  isWaterFilterationEN: PropTypes.bool,
  isFreeStandingBath: PropTypes.bool,
};

export default HomeArticleCard;
